import { render } from "./AboutClientSingle.vue?vue&type=template&id=2bf2a224&scoped=true"
import script from "./AboutClientSingle.vue?vue&type=script&lang=js"
export * from "./AboutClientSingle.vue?vue&type=script&lang=js"

import "./AboutClientSingle.vue?vue&type=style&index=0&id=2bf2a224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf2a224"]])

export default __exports__